import { render, staticRenderFns } from "./pro-collect.vue?vue&type=template&id=7d62025e&scoped=true&"
import script from "./pro-collect.vue?vue&type=script&lang=js&"
export * from "./pro-collect.vue?vue&type=script&lang=js&"
import style0 from "./pro-collect.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./pro-collect.vue?vue&type=style&index=1&id=7d62025e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d62025e",
  null
  
)

export default component.exports